import { selectWarehouse, updateWarehouse } from 'containers/Warehouses/warehousesSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { useRef, useState } from 'react'
import { POST } from 'rest/request'
import { api } from 'rest/urls'

// const DELAY = 10_000

const useWarehouseAction = (
  warehouseId: string
) => {
  const { doorState, actions, isShared, permissions, inFuture, hasAccess } = useReduxSelector(state => selectWarehouse(state, warehouseId))
  const [isSending, setSending] = useState(false)

  const hasPermissionsToOpen = !isShared || permissions?.includes('entry')
  const requiredAction = actions?.warehouse?.open
  const disabled = isSending || !hasPermissionsToOpen || !requiredAction || inFuture || !hasAccess
  const currentDoorState = useRef(doorState)
  currentDoorState.current = doorState

  const dispatch = useReduxDispatch()
  const updateStatus = (lock: warehouse.WarehouseLockState) => {
    dispatch(updateWarehouse({
      id: warehouseId,
      values: { doorState: { ...currentDoorState.current, lock } }
    }))
  }

  const action = async () => {
    if (disabled) return
    try {
      if (requiredAction.type === 'request' && requiredAction.method === 'POST') {
        setSending(true)
        const body = requiredAction.payload
        const response = await POST(`${api}${requiredAction.url}`, { body })
        if (response?.result === 'ok') {
          setSending(false)
          updateStatus('unlocked')
          // setTimeout(() => {
          //   updateStatus('locked')
          // }, DELAY)
        } else {
          throw new Error('Wrong response')
        }

      } else {
        throw new Error('No supported action')
      }
    } catch (error) {
      setSending(false)
      console.error(error)
    }
  }

  return {
    disabled,
    isSending,
    hasPermissionsToOpen,
    action
  }
}

export default useWarehouseAction